import {} from '@/hooks/useTabs';
import { Controls, ControlItem, ControlIcon } from './ControlsCarousel.styles';

type ControlsCarouselProps = {
  activeIndex: number;
  isNextArrowDisabled: boolean;
  isPrevArrowDisabled: boolean;
  numberOfItems: number;
  onClickNext: () => void;
  onClickPrevious: () => void;
  setActiveIndex: (index: number) => void;
};

const ControlsCarousel = ({
  activeIndex,
  isNextArrowDisabled,
  isPrevArrowDisabled,
  numberOfItems,
  onClickNext,
  onClickPrevious,
  setActiveIndex,
}: ControlsCarouselProps) => {
  return (
    <Controls>
      <button
        aria-label="Previous"
        disabled={isPrevArrowDisabled}
        onClick={() => {
          onClickPrevious();
        }}
        type="button"
      >
        <ControlIcon className="icon" name="bx-chevron-left" isDisabled={isPrevArrowDisabled} />
      </button>
      {[...Array(numberOfItems).keys()].map((index) => (
        <ControlItem
          aria-label={`Control item ${index}`}
          isActive={activeIndex === index}
          key={index}
          onClick={() => setActiveIndex(index)}
        />
      ))}
      <button
        aria-label="Next"
        disabled={isNextArrowDisabled}
        onClick={() => {
          onClickNext();
        }}
        type="button"
      >
        <ControlIcon className="icon" name="bx-chevron-right" isDisabled={isNextArrowDisabled} />
      </button>
    </Controls>
  );
};

export default ControlsCarousel;
